import { PreviewsStatus, type PreviewsStatusProps } from '../../../components/shared/BudgetPreviewsStatus/types.ts'

const ADD_SERVICE_ALLOWED_PREVIEW_STATUSES: PreviewsStatusProps[] = [
  PreviewsStatus.NOT_STARTED,
  PreviewsStatus.IN_PROGRESS,
  PreviewsStatus.RETURNED_GU
]

interface ClientPreviewStatusItem {
  previewNumber: number
  previewStatus: {
    code: PreviewsStatusProps
  }
}

interface GetClientDefaultPreviewNumberParams {
  currentPreviewNumber?: number
  previewStatus: ClientPreviewStatusItem[]
}

export const getClientDefaultPreviewNumber = ({
  currentPreviewNumber,
  previewStatus
}: GetClientDefaultPreviewNumberParams): number => {
  const currentPreviewStatus = previewStatus.find((item) => item.previewNumber === currentPreviewNumber)?.previewStatus
    .code

  if (
    currentPreviewNumber !== undefined &&
    currentPreviewStatus &&
    ADD_SERVICE_ALLOWED_PREVIEW_STATUSES.includes(currentPreviewStatus)
  ) {
    return currentPreviewNumber
  }

  return (
    previewStatus.find((item) => ADD_SERVICE_ALLOWED_PREVIEW_STATUSES.includes(item.previewStatus.code))
      ?.previewNumber ||
    currentPreviewNumber ||
    1
  )
}
